module.exports = __webpack_public_path__ + "static/img/wechat111.d41d8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wechat111.png
// module id = 4h59
// module chunks = 10